import axios from 'axios'
import store from '../store';
// import NProgress from 'nprogress'

const OrgapiClient = axios.create({
    baseURL: process.env.VUE_APP_ORG_API_URL,
    withCredentials: true, // This is the default
})
OrgapiClient.interceptors.request.use(config => { // Called on request
    // NProgress.start()
    store.state.layout.isLoading = true;
    return config
})
OrgapiClient.interceptors.response.use(response => { // Called on response
    // NProgress.done()

    store.state.layout.isLoading = false;

    return response
})
// OrgapiClient.defaults.headers.common['x-requested-with'] = 'xmlhttprequest';
export default OrgapiClient